import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

import '../css/Chat.css';  // Custom styles for the chat component

const ChatFooter = ({ handleSendMessage }) => {
  const [localInput, setLocalInput] = useState(''); // Local state for input

  // Handle input when button is clicked
  const handleButtonClick = (e) => {
    e.preventDefault();
    handleSendMessage(localInput); // Call the parent function with local input
    setLocalInput(''); // Clear the input field
  };

  // Handle input changes
  const handleInputChange = (e) => {
    setLocalInput(e.target.value); // Update local input state
  };

  return (
    <div className="chat-footer">
      <Form className="d-flex">
        <Form.Control
          type="text"
          value={localInput}
          placeholder="Type a message..."
          className="me-2"
          onChange={handleInputChange} // This will prevent the warning
        />
        {/* Pass the function reference to onClick without invoking it */}
        <Button type="submit" variant="danger" onClick={handleButtonClick}>
          <span  style={{ color: '#f8f9fa' }}>Senden</span>
        </Button>
      </Form>
    </div>
  );
};

export default ChatFooter;
/*
const ChatFooter = ({ chatInput, handleInputChange, handleSendMessage }) => {
  return (
    <div className="chat-footer">
      <Form onSubmit={handleSendMessage} className="d-flex">
        <Form.Control
          type="text"
          value={chatInput}
          onChange={handleInputChange}
          placeholder="Type a message..."
          className="me-2"
        />
        <Button type="submit" variant="primary">Senden</Button>
      </Form>
    </div>
  );
};

export default ChatFooter;
*/